import Crud from '../views/AutoInsurance/Crud'
import Entity from '../views/AutoInsurance/Add'

let routes = {
    path: '/auto_insurances',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/auto_insurances/add',
            name: 'NewAutoInsurance',
            component: Entity,
            meta: {
                ability: 'seguros.gerenciar',
                pageTitle: 'Insurance',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/auto_insurances'
                    },
                    {
                        text: 'Add',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/auto_insurances/edit/:id?',
            name: 'EditAutoInsurance',
            component: Entity,
            meta: {
                ability: 'seguros.gerenciar',
                pageTitle: 'Insurance',
                breadcrumb: [
                    {
                        text: 'List',
                        active: false,
                        to:'/auto_insurances'
                    },
                    {
                        text: 'Edit',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/auto_insurances',
            name: 'list-auto_insurances',
            component: Crud,
            meta: {
                ability: 'seguros.ver',
                pageTitle: 'Insurance',
                breadcrumb: [
                    {
                        text: 'List',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
